module.exports = __webpack_public_path__ + "static/media/preview_chart_1_Revenue.38ce3a47.PNG";